import { render } from "./InstanceTile.vue?vue&type=template&id=5f0a471a"
import script from "./InstanceTile.vue?vue&type=script&lang=js"
export * from "./InstanceTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__